import {
  Component,
  OnInit,
  Inject,
  forwardRef,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { OSideMenuModule, OSideMenuComponent } from './o-side-menu.component';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_SIDE_MENU_ITEM = [
  // title [string]: menu item title. Default: no value.
  'title',

  // icon [string]: material icon. Default: no value.
  'icon',

  // route [string]: name of the state to navigate. Default: no value.
  'route',

  // action [function]: function to execute. Default: no value.
  'action'
];


export class OSideMenuItemComponent implements OnInit {

  public static DEFAULT_INPUTS_O_SIDE_MENU_ITEM = DEFAULT_INPUTS_O_SIDE_MENU_ITEM;

  protected menu: OSideMenuComponent;

  protected _title: string;
  protected _icon: string;
  protected _route: string;
  protected _action: Function;

  protected _restricted: boolean;

  constructor(  menu: OSideMenuComponent) {
    this.menu = menu;
  }

  public ngOnInit() {
    if (typeof (this.route) === 'string') {
      this.menu.getAuthGuardService().isRestricted(this.route)
        .then(restricted => this.restricted = restricted)
        .catch(err => this.restricted = true);
    } else {
      this.restricted = false;
    }
  }

  get title(): string {
    return this._title;
  }

  set title(val : string) {
    this._title = val;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(val : string) {
    this._icon = val;
  }

  get route(): string {
    return this._route;
  }

  set route(val : string) {
    this._route = val;
  }

  get action(): Function {
    return this._action;
  }

  set action(val : Function) {
    this._action = val;
  }

  get restricted(): boolean {
    return this._restricted;
  }

  set restricted(val : boolean) {
    this._restricted = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-side-menu-item',
  template: `
    <a *ngIf="!restricted && action === undefined && route !== undefined" class="mat-list-item-content" [routerLink]="[ route ]">
      <md-icon *ngIf="icon" class="o-side-menu-item-icon mat-24">{{ icon }}</md-icon>
      <div class="o-side-menu-item-title">{{ title | oTranslate }}</div>
    </a>
    <a *ngIf="!restricted && route === undefined && action !== undefined" class="mat-list-item-content" (click)="action()">
      <md-icon *ngIf="icon !== undefined" class="o-side-menu-item-icon mat-24">{{ icon }}</md-icon>
      <div class="o-side-menu-item-title">{{ title | oTranslate }}</div>
    </a>
    <div *ngIf="!restricted && route !== undefined && action === undefined" class="o-side-menu-item-text mat-list-item-content">
      <md-icon *ngIf="icon !== undefined" class="o-side-menu-item-icon mat-24">{{ icon }}</md-icon>
      <div class="o-side-menu-item-title">{{ title | oTranslate }}</div>
    </div>
  `,
  styles: [`
    o-side-menu-item .mat-list-item-content{display:flex;justify-content:flex-start;align-items:center;height:auto;min-height:45px;padding:0px 10px}o-side-menu-item .o-side-menu-item-text{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;box-sizing:border-box;font-size:16px;height:48px;padding:0 16px}o-side-menu-item .o-side-menu-item-icon{margin:0px 10px 0px 0px}o-side-menu-item .o-side-menu-item-icon ~ .o-side-menu-item-title{padding-left:0px}o-side-menu-item .o-side-menu-item-title{position:relative;top:1px;padding-left:33px}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_SIDE_MENU_ITEM
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OSideMenuComponent, decorators: [{ type: Inject, args: [forwardRef(() => OSideMenuComponent), ] }, ]},
];
}



export class OSideMenuItemModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OSideMenuItemComponent],
  imports: [OSharedModule, CommonModule, RouterModule, OSideMenuModule],
  exports: [OSideMenuItemComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
